import { Box, Typography, useTheme } from '@mui/material';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import { useTranslation } from 'react-i18next';

const PrimaryGenreSwitch = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <MusicNoteIcon
        sx={{
          width: theme.spacing(5.5),
          height: theme.spacing(5.5),
          background: theme.palette.grey[50],
          color: theme.palette.grey[900],
          borderRadius: '50%',
          padding: theme.spacing(1.4),
        }}
      />
      <Typography
        color={theme.palette.grey[400]}
        fontSize={theme.spacing(1.375)}
        lineHeight={theme.spacing(2)}
        fontWeight={500}
        letterSpacing={0}
        mt={theme.spacing(0.5)}
      >
        {t('aiMusicGenerator:lockedField:genre')}
      </Typography>
    </Box>
  );
};

export default PrimaryGenreSwitch;
